<div class="eos-report-container">
  <app-search-box [config]="searchBoxConfig" (searchBoxChange)="onSearchBoxChanged()">
    <ng-container slot="search-section-actions">
      <button type="button" class="eos-btn-primary" mat-flat-button (click)="onExportCSVBtnClick()">Export CSV</button>
      <button type="button" class="eos-btn-primary" mat-flat-button (click)="onExportPDFBtnClick()">Export PDF</button>
    </ng-container>
  </app-search-box>
  <app-table [config]="tableConfig" [serverSideDatasource]="serverSideDatasource"></app-table>
</div>
